import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Dialog from "@mui/material/Dialog";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import MainComponent from "./components/MainComponent/MainComponent";
import Login from "./components/Login/Login";
import "./App.css";
import { ToastContainer } from "react-toastify";
import { DialogContent } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header/Header";
import Signup from "./components/Signup/Signup";
import ForgotPass from "./components/ForgotPassword/ForgotPassword";
import Reset from "./components/ResetPassword/ResetPassword";
import Verification from "./components/Verification/Verification";
import VerificationValidation from "./components/Signup/Verification";
import SEO from "./components/Seo/Seo";
import Policy from "./components/ShowcasaTerms/Policy";
import TermsAndConditions from "./components/ShowcasaTerms/Terms";
import AppProviders from "./AppProviders";
import { showToast } from "./components/Toast/CommonToast";
import { IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
const Subscription = React.lazy(() => import('./components/Subscription/Subscription'));
 
// Define prop types for DrawerComponent and MainComponent
 
function MainContent(): JSX.Element | null  {
   const [openPopup, setOpenPopup] = useState(false);
 
  // ===========================
  // CENTRALIZED STYLES
  // ===========================
  const styles = {
    dialogContent: {
      position: "relative",
      textAlign: "center",
      py: 4,
      px: 3,
    },
    closeButton: {
      position: "absolute",
      top: 12,
      right: 12,
      color: "rgba(255, 255, 255, 0.7)",
      "&:hover": {
        color: "rgba(255, 255, 255, 1)",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      },
    },
    welcomeText: {
      fontWeight: 600,
      mb: 1.5,
      color: "#fff",
    },
    popupTitle: {
      color: "rgba(255, 255, 255, 0.8)",
      fontSize: "0.95rem",
      lineHeight: 1.6,
      maxWidth: "280px",
      margin: "0 auto",
    },
    mainBox: {
      display: "flex",
      flexDirection: "column",
    },
  };
 
   React.useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const message = params.get("message");
      const error = params.get("error");
      if (message) {
        showToast(decodeURIComponent(message), "error");
      }
      if (error) {
        showToast(decodeURIComponent(error), "error");
      }
    }, []);
 
    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const userEncoded = params.get("user");
      const authEncoded = params.get("auth");
      if (userEncoded && authEncoded) {
        try {
          const userStr = atob(decodeURIComponent(userEncoded));
          const authStr = atob(decodeURIComponent(authEncoded));
          const user = JSON.parse(userStr);
          const auth = JSON.parse(authStr);
          setOpenPopup(true);
 
          if(user){
            localStorage.setItem("userId", (user._id || user.id));
            localStorage.setItem("name", (user.name));
            localStorage.setItem("email", (user.email));
            localStorage.setItem("isGoogleLogin", (user.isGoogleLogin));
          }
          if (auth.token) localStorage.setItem("accessToken", (auth.token));
          if (auth.refreshToken) localStorage.setItem("refreshToken", (auth.refreshToken));
          if(auth){
            localStorage.setItem("isVerified", (auth?.user?.verified));
          }
        } catch (e) {
          // Ignore errors
          console.error("Failed to parse user/auth params", e);
        }
      }
    }, []);
 
  const handleClosePopup = () => {
    setOpenPopup(false);
    // Redirect to the same path without query params after closing popup
    window.location.replace(window.location.pathname);
  };
 
useEffect(() => {
  if (openPopup) {
    const timer = setTimeout(() => {
      handleClosePopup();
    }, 3000);
 
    return () => clearTimeout(timer);
  }
}, [openPopup]);
 
  const location = useLocation();
  const userId = localStorage.getItem("userId") || "";
  const modelIdVideo = '67ed04b99104e4df3945139c';
  const modelIdImage = localStorage.getItem("imageEventId") || "67a9ae84c578669ec343933d";
  const cartoonImage = localStorage.getItem("cartoonModelId") || "68146db837ac9f090a4ca50a";
  const podcastId = localStorage.getItem("podcastModelId") || "6812186837ac9f090a4ca4fd";
  const AIInfluencerCharacter = localStorage.getItem("aiInfluencerCharacterID") || "683422b3227c23ad8919e8be";
  const AIInfluencerVariation = localStorage.getItem("aiVariationID") || "6834224e227c23ad8919e8bd";
  const photoTalksId = localStorage.getItem("photoTalksModelId") || "684fc10aae6234d0dcf96cde";
  const productScapeId = localStorage.getItem("productScapeModelId") || "684a5da3ed3f46be2271c921";
  const showcaseId = localStorage.getItem("showcaseModelId") || "6853fabf1c0892b44fc8be80";
  const audioId = localStorage.getItem("audioEventId") || "68590b5ec4e2a96de6be37dc";
  const audioIdRamp = localStorage.getItem("rampEventID") || "685e428e94e0f8921c36a887"
  const reelsId = localStorage.getItem("audioEventId") || "68590b5ec4e2a96de6be37dc";
  const rampId = localStorage.getItem("rampEventID") || "685e428e94e0f8921c36a887";
    const isPhotoTalks = location.pathname === "/studio/photo-talks";
  const voiceModelId = isPhotoTalks ? photoTalksId : podcastId;
 
  const authRoutes = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path='/verify/:verificationId' element={<Verification />} />
      <Route path="/forgot" element={<ForgotPass />} />
      <Route path="/reset-password/:resetPasswordId" element={<Reset />} />
      <Route path="/reset-password" element={<Reset />} />
      <Route path="/verification" element={<VerificationValidation />} />
      <Route path='/privacy-policy' element={<Policy />} />
      <Route path='/terms-of-service' element={<TermsAndConditions />} />
      <Route path="*" element={<Login />} />
    </Routes>
  );
 
  const isAuthRoute =
    location.pathname === '/terms-of-service' ||
    location.pathname === '/privacy-policy' ||
    location.pathname === '/verification' ||
    location.pathname === '/login' ||
    location.pathname === '/signup' ||
    location.pathname === '/forgot' ||
    location.pathname.startsWith("/reset-password") ||
    location.pathname === "verification";
 
  const isSubscriptionRoute = location.pathname === '/subscription';
  const params = new URLSearchParams(location.search);
  const hasSubscriptionParams = !!params.get('encryptRedirectToken') && !!params.get('method');
  const isPublicSubscription = isSubscriptionRoute && hasSubscriptionParams;
  
  // If it's public subscription page, render it directly without auth check
  if (isPublicSubscription) {
    console.log("Public subscription detected");
    return (
      <Routes>
        <Route path="/subscription" element={<Subscription />} />
      </Routes>
    );
  }
 
  if (isAuthRoute || !userId) {
    return authRoutes;
  }
 
  // Only wrap with WebSocket providers if userId exists
  if (userId) {
  return (
    <>
       <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        className="signinPopup"
        maxWidth="xs"
        fullWidth
      >
        <DialogContent sx={styles.dialogContent}>
          <IconButton
            onClick={handleClosePopup}
            sx={styles.closeButton}
            aria-label="close"
          >
            <Close />
          </IconButton>
 
          <img src="/app-logo.png" alt="App Logo" className="popupLogoIcon" />
 
          <Typography variant="h5" sx={styles.welcomeText}>
            Welcome!
          </Typography>
 
          <Typography sx={styles.popupTitle}>
            You have successfully signed in to your account.
          </Typography>
        </DialogContent>
      </Dialog>
 
        <AppProviders
          userId={userId}
          cartoonImage={cartoonImage}
          modelIdImage={modelIdImage}
          modelIdVideo={modelIdVideo}
          podcastId={podcastId}
          AIInfluencerCharacter={AIInfluencerCharacter}
          AIInfluencerVariation={AIInfluencerVariation}
          photoTalksId={photoTalksId}
          productScapeId={productScapeId}
          showcaseId={showcaseId}
          audioId={audioId}
          reelsId={reelsId}
          rampId={rampId}
          audioIdRamp={audioIdRamp}
          voiceId={voiceModelId}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CssBaseline />
            <Header />
            <MainComponent open={true} />
          </Box>
        </AppProviders>
      </>
    );
  } else {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
}
 
 
export default function PersistentDrawerLeft(): JSX.Element {
  return (
    <Router>
      <ToastContainer />
      <SEO />
      <MainContent />
    </Router>
  );
}
 